import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { CommonService } from 'src/services/common.service';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { EnvService } from './env.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, AfterViewInit ,OnInit  {

  title = 'Agent';
  areas:any[] = [];
  saveAreas:any[] = [];
  showReport = false;
  isLogin= false;

  constructor(private env: EnvService, private commonService: CommonService, private router: Router, private activatedRoute: ActivatedRoute,) {

    // this.provincesUrl = this.env.provincesUrl;
    let urlx= window.location.pathname;

    if(urlx?.toString().includes('/report') )
    {
        this.showReport = true;
  
    }
   }
  ngOnDestroy() {
    // debugger; 
    // this.signalRService.stopConnection();
    // this.keyboardShow = false;
  }
  titleSeo="LG Vina Cosmetic";
  areaGroup:any[] = [];
  provinces: ProvinceModel[] = [];
  changeArea(area: string)
  {
    debugger;
    if(area?.length > 0)
    {
      this.provinces = this.areaGroup.find(x=>x.area === area).lines;
      this.changeProvince(area, "");
    }
    else
    {
      this.provinces = [];
      this.areas = this.saveAreas;
    } 
    
  }
  scrollToDiv(divId: string)
  {
    const scrollTo = document.getElementById(divId);// (".kselected");
    if (scrollTo) {
      setTimeout(() => { 
        scrollTo.scrollIntoView({ behavior: 'smooth' });
      }, 10); 
    }
  }
  changeProvince(area: string, province: string)
  {
    debugger;
    if(area?.length > 0)
    {
      this.areas = this.areaGroup.find(x=>x.area === area).lines;
    }
    if(province?.length > 0)
    {
      this.areas =  this.areas.filter(x=>x.province === province);
    } 
  }
  filterKey(keyword: string)
  {
    
    if(keyword?.length > 0)
    {
      this.areas =  this.saveAreas.filter(x=>x.province?.toLowerCase().includes(keyword) || x.agentName?.toLowerCase().includes(keyword) || x.area?.toLowerCase().includes(keyword));
    }
    else
    {
      this.areas =  this.saveAreas;
    }
     
  }
  register(txtName: string,  txtCompany: string, txtPhone: string, txtBirthDay: string, txtEmail: string, txtSponsor: string,  ddlArea: string)
  {
    // 
    let model = new MDAGENTPROFILEModel();
     
    model.agentName = txtName;
    model.areaCode = ddlArea; 
    model.birthday =  txtBirthDay; 
    model.email = txtEmail;
    model.mobilePhone = txtPhone;
    model.customF1 = txtSponsor;
    model.customF2 = txtCompany;
    // model.mobilePhone = txtPhone;

    this.commonService.RegisAgent(model).subscribe((response: any)=>{
      if(response.success)
      {
         Swal.fire('Thành công','Đăng ký thành công. ', 'success');
      }
      else
      {
        Swal.fire('Không thành công',  response.errorMessage, 'warning'); 
      }
    }, error =>{
      Swal.fire('Không thành công','Đăng ký không thành công. Vui lòng liên hệ', 'error'); 
    });
  }
  angentInMap: any[] = [];
  saveAngentInMap: any[] = [];
  selectedDate: NgbDateStruct;
  GetAgentInMap()
  {
    this.commonService.GetAgentInMap().subscribe((response: any[]) =>
    {
      // this.angentInMap = response;
      // this.saveAngentInMap = response; 
      if(response!==null && response!==undefined && response?.length > 0)
      {
        this.saveAreas.forEach((element: any) => {
          let latX = response.find(x=>x.agentCode === element.agentCode);
          if(latX!==null && latX!==undefined)
          {
            if(latX?.long!==null && latX?.long!==undefined && latX?.long?.length > 0)
            {
              element.long = latX?.long;
            }
            if(latX?.lat!==null && latX?.lat!==undefined && latX?.lat?.length >0)
            {
              element.lat = latX?.lat;
            }
            
          }
          
        });
      }
     
      // console.log('this.angentInMap',this.angentInMap);
    })
  }
  GetAreaRegis()
  {
    this.commonService.GetAreaRegis().subscribe((response: any) =>
    {
      this.areas = response;
      this.saveAreas = response;
     
      var areaGroups = this.areas.reduce(function (obj: any, item: any) {

        obj[item.area] = obj[item.area] || [];
        obj[item.area].area = item.area;
        if(obj[item.area]?.lines ==null || obj[item.area]?.lines ===undefined || obj[item.area]?.lines?.length === 0)
        {
          obj[item.area].lines = [];
        }
        obj[item.area].lines.push(item);

        return obj;
      }, {});
      
      let responseProps = Object.keys(areaGroups);
      
      let cashierPaymentResponse = [];

      for (let prop of responseProps) {

        cashierPaymentResponse.push(areaGroups[prop]);
      }

      this.areaGroup = cashierPaymentResponse.sort((a, b) => a.cashier !== b.cashier ? a.cashier < b.cashier ? -1 : 1 : 0);



      // this.paymentsGroup.forEach(element => { 
      //   element.totalAmt = element.reduce(
      //     (a, b) => b.totalAmt + a,
      //     0); 
      // });

    })
  }
  // @ViewChild('divPageLoad', { static: false }) divPageLoad;
  @ViewChildren('divPageLoad') divPageLoad: ElementRef;
  isloaded = false;
  logOut()
  {
    setTimeout(() => {
    debugger;

      localStorage.clear();
      // localStorage.setItem("AgentUser", null);
      this.router.navigate(['/']).then(()=>{
        window.location.reload();
      });

    }, 100);
  
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.isloaded = true;

      if(this.isLogin && this.showReport )
      {
        this.showLogOut = true;
      }
    }, 100);
    // this.divPageLoad.nativeElement.remove();
    // const paymentMenu = document.getElementsByClassName('ng-star-inserted');
    // Array.prototype.forEach.call(paymentMenu, function (item) {
    //   // Do stuff here
    //   if (item !== null && item !== undefined) {
    //     item.classList.remove('ng-star-inserted');
    //     item.classList.add('');
    //   }
    // });
    // if ($('#pageloader').length > 0) {
            
    //   $window.on('load', function () {
    //     $('#pageloader').fadeOut('slow');
    //     // $window.trigger("resize");
    //   });
    // } else {
    //   $('#pageloader').remove();
    // };

  }
  showLogOut = false;
  ngOnInit() {
    // this.GetAreaRegis();
    // this.GetAgentInMap();
    this.isLogin = this.loggedIn();
  
  }

  loggedIn() {
    const user = localStorage.getItem('AgentUser');
    let result = false;
    if(user=== null || user === undefined)
    {
      result = false;
    }
    else
    {
      result = true;
    }
    return result;
  }


}

export class ProvinceModel { 
    code: number; 
    name: string; 
    codename: string;
    division_type: string;  
    phone_code: string;  
    districts: ProvinceModel[];
    short_codename: string; 
    wards: ProvinceModel[];   
}

export class BMAreaRegisModel { 
    id: number; 
    region: string; 
    area: string;
    province: string;  
    agentCode: string;  
    agentName: string;
    agentPersonal: string; 
    address: string; 
    email: string;
    phone: string;
    status: boolean;
    long: string;
    lat: string;

}

export class MDAGENTPROFILEModel {

  id: number;
  agentCode: string;
  agentName: string;
  areaCode: string;
  address1: string;
  taxCode: string;
  oPhoneNum: string;
  paymentMethod: string;
  creditAmount: number;
  ceoName: string;
  gender: string;
  birthday: Date | string | null;
  address2: string;
  mobilePhone: string;
  contactPerson: string;
  email: string;
  comment: string;
  placeOfBusiness: string;
  mobileNumber2: string;
  actionBy: string;
  status: string; 
  createFrom: string;
  customF1: string;
  customF2: string;
  customF3: string;
  customF4: string;
  customF5: string; 
  host: string; 
  fullAddress: string; 

  duration: number | null;
}